import {useEffect, useState, forwardRef, useImperativeHandle, useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import EditFieldGroup from "../../../components/EditFieldGroup";
import EditField from "../../../components/EditFieldGroup/EditField";
import CampaignType from "./Dropdowns/CampaignType";
import CampaignStatus from "./Dropdowns/CampaignStatus";
import DatePicker from "react-datepicker";
import ParentCampaign from "./Dropdowns/ParentCampaign";
import CampaignRegion from "./Dropdowns/CampaignRegion";
import CampaignSubsidiary from "./Dropdowns/CampaignSubsidiary";
import CampaignSegment from "./Dropdowns/CampaignSegment";
import CampaignIndustry from "./Dropdowns/CampaignIndustry";
import moment from 'moment';
import Button from "../../../components/Button";
import Toaster from "../../../components/Toaster";
import * as campaignActions from "../../../redux/Campaign/actions";
import CampaignVendor from "./Dropdowns/CampaignVendor";
// import { WithContext as ReactTags } from 'react-tag-input';
import ContactSelect from "../../../components/ContactSelect";
import './EditCampaign.scss';

const EditCampaign = forwardRef((props, ref) => {
	const {editCampaign, onClose} = props;
	const user = useSelector(state => state.user.user);
	const [startDate, setStartDate] = useState(editCampaign.start_date ? new Date(editCampaign.start_date) : new Date());
	const [endDate, setEndDate] = useState(editCampaign.end_date ? new Date(editCampaign.end_date) : new Date());
	const [replyCampaignId, setReplyCampaignId] = useState(editCampaign.reply_campaign_id || '');
	const [uniqueId, setUniqueId] = useState(editCampaign.unique_identifier || '');
	const [type, setType] = useState(editCampaign.campaign_type_id || '1');
	const [status, setStatus] = useState(editCampaign.campaign_status_id || '1');

	const [vendor, setVendor] = useState(editCampaign.vendor);
	const [description, setDescription] = useState(editCampaign.description || '');
		  const [parentCampaign, setParentCampaign] = useState(editCampaign.parent_campaign_id);
	const [nextStepPOC, setNextStepPOC] = useState(editCampaign.next_step_poc? {label: editCampaign.next_step_poc, value: '-1'} : null);
	const [region, setRegion] = useState(editCampaign.region_id);
	const [subsidiary, setSubsidiary] = useState(editCampaign.subsidiary_id);
	const [segment, setSegment] = useState(editCampaign.company_segment_id);
	const [industry, setIndustry] = useState(editCampaign.industry_id);

	const [nextStep, setNextStep] = useState(editCampaign.next_step || '');
	const [nextStepDate, setNextStepDate] = useState(editCampaign.next_step_date ? new Date(editCampaign.next_step_date) : new Date());
	const [resetDropdowns, setResetDropdowns] = useState(1);

	const campaignTypes = useSelector(state => state.campaign.dropdowns["CampaignType"]);
	const campaignStatuses = useSelector(state => state.campaign.dropdowns["CampaignStatus"]);
	const campaignIndustries = useSelector(state => state.campaign.dropdowns["CampaignIndustry"]);
	const campaignRegions = useSelector(state => state.campaign.dropdowns["CampaignRegion"]);
	const campaignSegments = useSelector(state => state.campaign.dropdowns["CampaignSegment"]);
	const campaignSubsidiaries = useSelector(state => state.campaign.dropdowns["CampaignSubsidiary"]);
	const parentCampaigns = useSelector(state => state.campaign.dropdowns["ParentCampaign"]);

	const [isManual, setIsManual] = useState(editCampaign.is_manual || false);
	// const [numProspects, setNumProspects] = useState(editCampaign['#_of_prospects'] || '');
	// const [numSent, setNumSent] = useState(editCampaign['#_sent'] || '');
	// const [numResponses, setNumResponses] = useState(editCampaign['#_of_responses'] || '');
	// const [numInCommunication, setNumInCommunication] = useState(editCampaign['#_in_communication'] || '');
	// const [numContacted, setNumContacted] = useState(editCampaign['#_contacted'] || '');
	// const [numOutOfScope, setNumOutOfScope] = useState(editCampaign['#_out_of_scope'] || '');
	// const [numConverted, setNumConverted] = useState(editCampaign['#_of_prospects_converted'] || '');

	const vendors = [
		{ value: 'aws', label: 'AWS'},
		{ value: 'ms', label: 'MS'}
	];

	const editMode = editCampaign.campaign_id != null;

	const KeyCodes = {
		comma: 188,
		enter: 13
	};

	const dispatch = useDispatch();

	useEffect(() => {
		const load = async () => {
			dispatch(campaignActions.loadDropdownValues("CampaignType"));
			dispatch(campaignActions.loadDropdownValues("CampaignStatus"));
			dispatch(campaignActions.loadDropdownValues("CampaignIndustry"));
			dispatch(campaignActions.loadDropdownValues("CampaignRegion"));
			dispatch(campaignActions.loadDropdownValues("CampaignSegment"));
			dispatch(campaignActions.loadDropdownValues("CampaignSubsidiary"));
			dispatch(campaignActions.loadDropdownValues("ParentCampaign"));
		};
		load();
	}, []);

	const campaignUpdated = (result) => {
		if(result.status === "ok") {
			Toaster.showSuccess("Campaign updated successfully.")
		}
		else {
			Toaster.showError(result.message)
		}
		onClose();
	};

	const campaignCreated = (result) => {
		if(result.status === "ok") {
			Toaster.showSuccess("Campaign created successfully.")
		}
		else {
			Toaster.showError(result.message)
		}
		onClose();
	};

	const updateCampaign = useCallback(() => {
		if(region == null || region.toString() === "-1") {
			Toaster.showError("Please select a Region");
			return;
		}

		// If Unique Identifier <> Null && Subsidiary <> Null:  {Account.Name} | {Subsidiary} {Type} Campaign {Start Date} ({Unique_Identifier})
		// Else: If Subsidiary <> Null && Unique Identifier = Null: {Account.Name} | Subsidiary } {Type} Campaign {Start Date}
		// Else: If Unique Identifier <> Null && Subsidiary = Null: {Account.Name} | {Type} Campaign {Start Date} ({Unique Identifier})
		// Else: Unique Identifier = Null && Subsidiary = Null: {Account.Name} | Region} {Type} Campaign {Start Date}

		let campaignName = `${vendor.toUpperCase()} | `;
		const sd = moment(startDate).format("YYYY-MM-DD");
		const ed = moment(endDate).format("YYYY-MM-DD HH:mm:ss");
		const selectedSubsidiary = (subsidiary == null ? null : campaignSubsidiaries.find(s => s.value.toString() === subsidiary.toString()));
		const selectedType = campaignTypes.find(s => s.value.toString() === type.toString());
		const selectedRegion = campaignRegions.find(s => s.value.toString() === region.toString());

		if(uniqueId.length > 0 && selectedSubsidiary && selectedSubsidiary.value !== "-1") {
			campaignName += `${selectedSubsidiary.label} ${selectedType.label} Campaign ${sd} ${uniqueId}`;
		}
		else if(uniqueId.length === 0 && selectedSubsidiary && selectedSubsidiary.value !== "-1") {
			campaignName += `${selectedSubsidiary.label} ${selectedType.label} Campaign ${sd}`;
		}
		else if(uniqueId.length > 0 && (selectedSubsidiary == null || selectedSubsidiary.value === "-1")) {
			campaignName += `${selectedType.label} Campaign ${sd} ${uniqueId}`;
		}
		else if(uniqueId.length === 0 && (selectedSubsidiary == null || selectedSubsidiary.value === "-1")) {
			campaignName += `${selectedRegion.label} ${selectedType.label} Campaign ${sd}`;
		}

		const campaign = {
			campaign_id: editCampaign.campaign_id,
			campaign_name: campaignName,
			type,
			vendor,
			unique_identifier: uniqueId,
			reply_campaign_id: replyCampaignId,
			start_date: moment(startDate).format("YYYY-MM-DD HH:mm:ss"),
			end_date: ed,
			status,
			description,
			region,
			next_step: nextStep,
			next_step_date: moment(nextStepDate).format("YYYY-MM-DD HH:mm:ss"),
			subsidiary: subsidiary && subsidiary.toString() !== "-1" ? subsidiary : 'NULL',
			company_segment: segment && segment.toString() !== "-1" ? segment : 'NULL',
			industry_of_focus: industry && industry.toString() !== "-1" ? industry : 'NULL',
			parent_campaign_id: parentCampaign && parentCampaign.toString() !== "-1" ? parentCampaign : 'NULL',
			is_manual: isManual,
			// num_of_prospects: numProspects,
			// num_sent: numSent,
			// num_of_responses: numResponses,
			// num_in_communication: numInCommunication,
			// num_contacted: numContacted,
			// num_out_of_scope: numOutOfScope,
			// num_of_prospects_converted: numConverted,
			next_step_poc: nextStepPOC&&nextStepPOC.value!='-1' ? nextStepPOC.value : null
		};
		if(campaign.status==editCampaign.campaign_status_id){
			delete campaign.status;
		}
		dispatch(campaignActions.saveCampaign(campaign, campaignUpdated));
	}, [editCampaign, type, vendor, uniqueId, replyCampaignId, startDate, endDate, status, description, region, nextStep, nextStepDate, subsidiary, segment, industry, parentCampaign, nextStepPOC, campaignSubsidiaries, campaignTypes, campaignRegions, isManual, dispatch]);

	const saveCampaign = useCallback(() => {
		if(vendor == null || vendor.toString() === "-1") {
			Toaster.showError("Please select a Vendor");
			return;
		}

		if(region == null || region.toString() === "-1") {
			Toaster.showError("Please select a Region");
			return;
		}

		// If Unique Identifier <> Null && Subsidiary <> Null:  {Account.Name} | {Subsidiary} {Type} Campaign {Start Date} ({Unique_Identifier})
		// Else: If Subsidiary <> Null && Unique Identifier = Null: {Account.Name} | Subsidiary } {Type} Campaign {Start Date}
		// Else: If Unique Identifier <> Null && Subsidiary = Null: {Account.Name} | {Type} Campaign {Start Date} ({Unique Identifier})
		// Else: Unique Identifier = Null && Subsidiary = Null: {Account.Name} | Region} {Type} Campaign {Start Date}

		let campaignName = `${vendor.toUpperCase()} | `;
		const sd = moment(startDate).format("YYYY-MM-DD");
		const ed = moment(endDate).format("YYYY-MM-DD HH:mm:ss");
		const selectedSubsidiary = campaignSubsidiaries.find(s => s.value.toString() === subsidiary);
		const selectedType = campaignTypes.find(s => s.value.toString() === type);
		const selectedRegion = campaignRegions.find(s => s.value.toString() === region);

		if(uniqueId.length > 0 && selectedSubsidiary && selectedSubsidiary.value !== "-1") {
			campaignName += `${selectedSubsidiary.label} ${selectedType.label} Campaign ${sd} ${uniqueId}`;
		}
		else if(uniqueId.length === 0 && selectedSubsidiary && selectedSubsidiary.value !== "-1") {
			campaignName += `${selectedSubsidiary.label} ${selectedType.label} Campaign ${sd}`;
		}
		else if(uniqueId.length > 0 && (selectedSubsidiary == null || selectedSubsidiary.value === "-1")) {
			campaignName += `${selectedType.label} Campaign ${sd} ${uniqueId}`;
		}
		else if(uniqueId.length === 0 && (selectedSubsidiary == null || selectedSubsidiary.value === "-1")) {
			campaignName += `${selectedRegion.label} ${selectedType.label} Campaign ${sd}`;
		}

		const campaign = {
			campaign_id: "-1",
			ownerEmail: user.email,
			ownerName: user.displayName,
			campaignName,
			accountName: user.accountName,
			vendor,
			type,
			status,
			uniqueId,
			replyCampaignId,
			startDate: moment(startDate).format("YYYY-MM-DD HH:mm:ss"),
			endDate: ed,
			description,
			region,
			nextStep,
			nextStepDate: moment(nextStepDate).format("YYYY-MM-DD HH:mm:ss"),
			is_manual: isManual,
			// num_of_prospects: numProspects,
			// num_sent: numSent,
			// num_of_responses: numResponses,
			// num_in_communication: numInCommunication,
			// num_contacted: numContacted,
			// num_out_of_scope: numOutOfScope,
			// num_of_prospects_converted: numConverted,
			next_step_poc: nextStepPOC ? nextStepPOC.value : null
		};

		if(subsidiary && subsidiary.toString() !== "-1") {
			campaign.subsidiary = subsidiary;
		}
		if(segment && segment.toString() !== "-1") {
			campaign.segment = segment;
		}
		if(industry && industry.toString() !== "-1") {
			campaign.industry = industry;
		}
		if(parentCampaign && parentCampaign.toString() !== "-1") {
			campaign.parentCampaign = parentCampaign;
		}

		dispatch(campaignActions.saveCampaign(campaign, campaignCreated));
	}, [type, vendor, uniqueId, startDate, endDate, status, description, region, nextStep, nextStepDate, subsidiary, segment, industry, parentCampaign, nextStepPOC, campaignSubsidiaries, campaignTypes, campaignRegions, isManual, dispatch]);

	// Expose save method to parent via ref
	useImperativeHandle(ref, () => ({
		save: editMode ? updateCampaign : saveCampaign
	}), [editMode, updateCampaign, saveCampaign]);

	const updateStartDate = (date) => {
		setStartDate(date);
		if(moment(date).isAfter(endDate)) {
			setEndDate(date);
		}
	};

	const onChangeNextStepPOC = (option) => {
		setNextStepPOC(option);
	}

	const vendorOnchange=(value)=>{
		setVendor(value);
		setResetDropdowns(resetDropdowns+1);
		setNextStepPOC(null)
	}

	if(campaignTypes == null ||
		campaignStatuses == null ||
		campaignIndustries == null ||
		campaignRegions == null ||
		campaignSegments == null ||
		campaignSubsidiaries == null ||
		parentCampaigns == null) {
		return <div></div>
	}

	return (
		<>
			<div className="edit-campaign-container">
				<EditFieldGroup title="Campaign Information">

					<EditField title="Is Manual">
							<input type="checkbox" className="checkbox-primary" checked={isManual} onChange={() => setIsManual(!isManual)} />
					</EditField>
					<EditField title="Campaign Owner">
						<div className="edit-field-styles-readonly">{user.displayName}</div>
					</EditField>

					<EditField title="Vendor" required>
						<CampaignVendor disabled={editMode} items={vendors} value={vendor} onChange={value => vendorOnchange(value)} />
					</EditField>

					<EditField title="Type">
						<CampaignType items={campaignTypes} value={type} onChange={value => setType(value)} />
					</EditField>
					<EditField title="Status">
						<CampaignStatus items={campaignStatuses} value={status} onChange={value => setStatus(value)} />
					</EditField>

					<EditField title="Start Date">
						<DatePicker selected={startDate}
						            selectsStart
						            onChange={updateStartDate}
						            className="calendar-field-styles" />
					</EditField>
					<EditField title="End Date">
						<DatePicker selected={endDate}
						            selectsEnd
						            minDate={startDate}
						            onChange={(date) => setEndDate(date)}
						            className="calendar-field-styles" />
					</EditField>

					<EditField title="Parent Campaign">
						<ParentCampaign items={parentCampaigns} value={parentCampaign} onChange={value => setParentCampaign(value)} />
					</EditField>
					{/*
					<EditField title="Reply.IO Campaign ID" styles={{alignItems: 'flex-start'}}>
						<input type="text" className="edit-field-styles" value={replyCampaignId} onChange={e => setReplyCampaignId(e.target.value)} />
					</EditField> */}

					<EditField title="Unique Identifier" styles={{alignItems: 'flex-start'}}>
						<input type="text" className="edit-field-styles" value={uniqueId} onChange={e => setUniqueId(e.target.value)} />
					</EditField>

					<EditField title="Description" styles={{alignItems: 'flex-start'}}>
						<textarea className="edit-field-styles"
						          value={description} onChange={e => setDescription(e.target.value)}
						          style={{height: '60px', resize:'none'}} />
					</EditField>
				</EditFieldGroup>

				<EditFieldGroup title="Segmentation">

					<EditField title="Region" required>
						<CampaignRegion items={campaignRegions} value={region} onChange={value => setRegion(value)} />
					</EditField>
					<EditField title="Subsidiary">
						<CampaignSubsidiary items={campaignSubsidiaries} value={subsidiary} onChange={value => setSubsidiary(value)} />
					</EditField>

					<EditField title="Industry">
						<CampaignIndustry items={campaignIndustries} value={industry} onChange={value => setIndustry(value)} />
					</EditField>
					<EditField title="Company Segment">
						<CampaignSegment items={campaignSegments} value={segment} onChange={value => setSegment(value)} />
					</EditField>

					<EditField title="Next Step">
						<input type="text" className="edit-field-styles" value={nextStep} onChange={e => setNextStep(e.target.value)} />
					</EditField>
					<EditField title="Next Step Date">
						<DatePicker selected={nextStepDate}
						            onChange={(date) => setNextStepDate(date)}
						            className="calendar-field-styles" />
					</EditField>
					<EditField title="Next Step POC">
						<ContactSelect
							reset={resetDropdowns}
							disabled={!vendor}
							vendor={vendor}
							value={nextStepPOC}
							onChange={onChangeNextStepPOC}
						/>
					</EditField>

				</EditFieldGroup>
				{/* <EditFieldGroup title="Results">
					<EditField title="# of Prospects">
						<input type="number" className="edit-field-styles" value={numProspects} onChange={e => setNumProspects(e.target.value)} />
					</EditField>
					<EditField title="# Sent">
						<input type="number" className="edit-field-styles" value={numSent} onChange={e => setNumSent(e.target.value)} />
					</EditField>
					<EditField title="# of Responses">
						<input type="number" className="edit-field-styles" value={numResponses} onChange={e => setNumResponses(e.target.value)} />
					</EditField>
					<EditField title="# in Communication">
						<input type="number" className="edit-field-styles" value={numInCommunication} onChange={e => setNumInCommunication(e.target.value)} />
					</EditField>
					<EditField title="# Contacted">
						<input type="number" className="edit-field-styles" value={numContacted} onChange={e => setNumContacted(e.target.value)} />
					</EditField>
					<EditField title="# Out of Scope">
						<input type="number" className="edit-field-styles" value={numOutOfScope} onChange={e => setNumOutOfScope(e.target.value)} />
					</EditField>
					<EditField title="# of Prospects Converted">
						<input type="number" className="edit-field-styles" value={numConverted} onChange={e => setNumConverted(e.target.value)} />
					</EditField>
				</EditFieldGroup> */}

			</div>

		</>
	)
});

export default EditCampaign;
